module.exports = __webpack_public_path__ + "img/skills-fireclaws-dru-2.2a3ddf71.png";